import type { ThemeState } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

export const getDefaultTheme = (): Partial<ThemeState> => {
	return {
		dark: 'dark',
		light: 'light',
		colorMode: fg('shared-user-preferences') ? 'auto' : 'light',
		typography: 'typography',
	};
};
